import React, { useState } from "react";
import { addCategory, addTypeToCategory } from "./api";

const AddCategoryForm = () => {
  const [categoryName, setCategoryName] = useState("");
  const [typeName, setTypeName] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [message, setMessage] = useState("");
  const [mode, setMode] = useState("category"); // toggle between add-category / add-type

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      if (mode === "category") {
        const response = await addCategory(categoryName);
        setMessage(`✅ ${response.message}`);
        setCategoryName("");
      } else {
        const response = await addTypeToCategory(categoryName, typeName, imageFile);
        setMessage(`✅ ${response.message}`);
        setTypeName("");
        setImageFile(null);
      }
    } catch (error) {
      setMessage(`❌ ${error.error || error}`);
    }
  };

  return (
    <div style={{ maxWidth: "500px", margin: "auto", padding: "20px" }}>
      <h2>{mode === "category" ? "Add Category" : "Add Type"}</h2>

      <div style={{ marginBottom: "10px" }}>
        <button onClick={() => setMode("category")} disabled={mode === "category"}>
          Add Category
        </button>
        <button onClick={() => setMode("type")} disabled={mode === "type"}>
          Add Type
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        <div>
          <label>Category Name:</label>
          <input
            type="text"
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            required
          />
        </div>

        {mode === "type" && (
          <>
            <div>
              <label>Type Name:</label>
              <input
                type="text"
                value={typeName}
                onChange={(e) => setTypeName(e.target.value)}
                required
              />
            </div>
            <div>
              <label>Image:</label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setImageFile(e.target.files[0])}
              />
            </div>
          </>
        )}

        <button type="submit" style={{ marginTop: "10px" }}>
          Submit
        </button>
      </form>

      {message && <p style={{ marginTop: "10px" }}>{message}</p>}
    </div>
  );
};

export default AddCategoryForm;
